//bootstrap
import { Button, Spinner } from "react-bootstrap";
//redux
import { useAppDispatch, useAppSelector } from "../../../../hooks";
// import { setStatusUpdateUser, selectStatusUpdateUser } from "../../../../redux/reducer/user/userSlice";
import { setStatusUpdate, selectStatusData } from "../../../../redux/reducer/client/clientSlice";

//----------------------------------------------------------

export default function Submit({ formik }: any) {
    //redux
    const dispatch = useAppDispatch();
    const { statusUpdate } = useAppSelector(selectStatusData);

    //function
    const switchButtons = () => {
        switch (statusUpdate) {
            case "init": {
                return (
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                    >
                        Dodaj klienta
                    </Button>
                );
            }
            case "load": {
                return (
                    <Button variant="primary" disabled>
                        <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                        <span className="visually-hidden">Loading...</span>
                    </Button>
                );
            }
            case "success": {
                return (
                    <Button variant="success" size="lg" disabled>
                        Klient został dodany
                    </Button>
                );
            }
            case "unsuccess": {
                return (
                    <Button
                        variant="warning"
                        size="lg"
                        onClick={() => {
                            dispatch(setStatusUpdate("init"));
                        }}
                    >
                        Dodanie nieudane
                    </Button>
                );
            }
            case "failed": {
                return (
                    <Button
                        variant="danger"
                        size="lg"
                        onClick={() => {
                            dispatch(setStatusUpdate("init"));
                        }}
                    >
                        Połączenie nieudane
                    </Button>
                );
            }
            default: {
            }
        }
    };

    //view
    return <>{switchButtons()}</>;
}
